<div
  class="remark-finalized"
  [class.remark-finalized--sealed]="remark.isSealed"
  [class.remark-finalized--first-in-group]="remark.grouping?.isFirst"
  [class.remark-finalized--last-in-group]="remark.grouping?.isLast"
  [class.remark-finalized--follows-sealed-content-marker]="remark.followsSealedContentMarker && !remark.isSealed"
>
  @if (showSpeaker) {
    @if (remark.isFirstRemarkOfMinute) {
      <ng-container *ngTemplateOutlet="time; context: { className: 'remark-finalized__time' }"></ng-container>
    }
    <div class="remark-finalized__content remark-finalized__content--speaker" [attr.data-datetime]="remark.startTime">
      <ng-container *ngTemplateOutlet="speaker"></ng-container>
      <ng-container *ngTemplateOutlet="text"></ng-container>
    </div>
  } @else {
    <div
      class="remark-finalized__content remark-finalized__content--no-speaker"
      [ngClass]="remark.isFirstRemarkOfMinute ? 'remark-finalized__content--no-speaker--first-remark-of-minute' : ''"
      [attr.data-datetime]="remark.startTime"
    >
      <ng-container
        *ngTemplateOutlet="timeOrEmpty; context: { className: 'remark-finalized__content-time' }"
      ></ng-container>
      <ng-container *ngTemplateOutlet="text"></ng-container>
    </div>
  }
</div>

<ng-template #timeOrEmpty let-className="className">
  @if (remark.isFirstRemarkOfMinute) {
    <ng-container *ngTemplateOutlet="time; context: { className: className }"></ng-container>
  }
  @if (!remark.isFirstRemarkOfMinute) {
    <div [class]="className"></div>
  }
</ng-template>

<ng-template #time let-className="className">
  <ftr-date
    [date]="remark.startTime"
    [format]="dateFormats.Time"
    [attr.data-datetime]="remark.startTime"
    [class]="className"
  ></ftr-date>
</ng-template>

<ng-template #speaker>
  <div
    [class.remark-finalized__content-speaker--current]="remark.isSpeakerActive"
    [class.remark-finalized__content-speaker--to-be-sealed]="remark.isSpeakerActive && remark.toBeSealed"
    class="remark-finalized__content-speaker"
  >
    @if (remark.isSpeakerActive) {
      <span class="remark-finalized__content-speaker-indicator">●</span>
    }
    <span
      [class.remark-finalized__content-speaker--highlight]="remark.isSpeakerActive"
      [class.remark-finalized__content-speaker--to-be-sealed]="remark.toBeSealed"
    >
      {{ remark.isFirstRemarkOfSpeaker ? remark.speakerName : '' }}
    </span>
  </div>
</ng-template>

<ng-template #text>
  <div class="remark-finalized__content-text">
    @for (content of remark.content; track content; let last = $last) {
      <span
        tabindex="0"
        [attr.data-remark-start]="remark.startTime"
        [class.remark-finalized__content-text--highlight]="remark.isRemarkBeingPlayed"
        [class.remark-finalized__content-text--to-be-sealed]="remark.toBeSealed"
        >{{ content }}</span
      >
      @if (!last) {
        <p></p>
      }
    }
  </div>
</ng-template>
